import create from 'zustand'

type IFeatureState = {
  features: string[]
  setFeatures: (features: string[]) => void
}

export const useFeatureState = create<IFeatureState>((set, get) => ({
  features: [],
  setFeatures: (features) => set({ features }),
}))
